module.exports = __webpack_public_path__ + "static/media/exprt-01.0b80a7ac.jpg";